import React, { useState } from 'react';
import { jsPDF } from "jspdf";
import './App.css';

export default function Textform(props) {

  const [bold, setBold] = useState(false);

  const toggleBold = () => {
    setBold(!bold);
  }

  const [under, setUnder] = useState(false);
  const makeunderline = () => {
    setUnder(!under);
  }
  const uppercase = () => {
    let newtext = text.toUpperCase();
    settext(newtext);
  }
  const [italic, setItalic] = useState(false);
  const toggleItalic = () => {
    setItalic(!italic);
  }
  const lowercase = () => {
    let newtext = text.toLowerCase();
    settext(newtext);
  }
  const handlecopy = () => {
    navigator.clipboard.writeText(text);
  }
  const cleartext = () => {
    let newtext = '';
    settext(newtext);
  }
  const clearspaces = () => {
    let newtext = text.split(/[ ]+/);
    settext(newtext.join(" "));
  }
  const handlechange = (event) => {
    settext(event.target.value);
  }

  const jspdf = new jsPDF('p', 'pt', 'letter')
  const makepdf = (e) => {
    e.preventDefault()
    const val = e.target.txt.value;
    const data = {
      callback: function (jspdf) {
        jspdf.save('formatted_text.pdf')
      },
      margin: [10, 10, 10, 10],

    }
    jspdf.html(val, data)
  }

  const [text, settext] = useState('');
  return (
    <>
      <div className="container" style={{ color: props.mode === 'dark' ? 'black' : 'white' }}>
        <p className=" fs-2 fw-semibold" >We provide free text formatting</p>
        <p className=" fs-6 fw-medium mb-4">Transform your text with our intuitive formatting tools. Apply bold, italic, or underline styles, choose from various text styles,  and conveniently download your customized content at the click of a button.</p>
        <form className="" onSubmit={(e) => makepdf(e)} >
          <textarea name='txt' className="form-control mb-3 mx-2" value={text} onChange={handlechange} style={{ backgroundColor: props.mode === 'dark' ? 'white' : '#13466e', color: props.mode === 'dark' ? 'black' : 'white', fontWeight: bold ? 'bold' : 'normal', fontStyle: italic ? 'italic' : 'normal', textDecoration: under ? 'underline' : 'none' }} id="exampleFormControlTextarea1" rows="8"></textarea>
          <button disabled={text.length === 0} className="btn btn-outline-danger btn-sm mx-2 my-2">Download PDF File</button>

        </form>
        <button disabled={text.length === 0} className="btn btn-outline-info mx-2 my-2 text-wrap button-cust" style={{}} onClick={cleartext}>Clear Text</button>
        <button disabled={text.length === 0} className="btn btn-outline-info mx-2 my-2 text-wrap button-cust" onClick={handlecopy}>Copy Text</button>
        <button disabled={text.length === 0} className="btn btn-outline-info mx-2 my-2 text-wrap button-cust" onClick={uppercase}>UpperCase</button>
        <button disabled={text.length === 0} className="btn btn-outline-info mx-2 my-2 text-wrap button-cust" onClick={lowercase}>LowerCase</button>

        <button disabled={text.length === 0} className="btn btn-outline-primary mx-2 my-2 text-wrap button-cust button-cust-text" onClick={clearspaces}>Remove Extra Space</button>
        <button disabled={text.length === 0} className="btn btn-outline-primary mx-2 my-2 text-wrap button-cust" onClick={toggleBold}>Bold Text</button>
        <button disabled={text.length === 0} className="btn btn-outline-primary mx-2 my-2 text-wrap button-cust" onClick={toggleItalic}>Italic Text</button>
        <button disabled={text.length === 0} className="btn btn-outline-primary mx-2 my-2 text-wrap button-cust button-cust-text" onClick={makeunderline}>Underline Text</button>

      </div>
      <div className="container my-4" style={{ color: props.mode === 'dark' ? '#042743' : 'white' }}>
        <h3><strong>Your text summary</strong></h3>
        <p>{text.split(" ").filter((element) => { return element.length !== 0 }).length} words, {text.length} characters</p>
        <p>{text.length > 0 ? " " : "Type Something..."}</p>
      </div>

    </>
  )
}